import { Runtime } from '@silvertours/front-entities';

/**
 * Hook to determine if the current page is a promotional page.
 * A promotional page is one that begins with 'promo' but is not in the excluded list.
 * @returns {Object} Object containing isPromotionalPage boolean
 */
export const useIsPromotionalPage = () => {
  const {
    page: { path },
  } = Runtime.useRuntime();

  // List of promotional paths that should be excluded
  const excludedPromoPaths = [
    'promo/fahrt20.html',
    'promo/schnellweg.html',
    'promo/rabatt20.html',
    'promo/black-friday.html',
  ];

  // Check if the path starts with 'promo' but is not in the excluded list
  const isPromotionalPage =
    path.startsWith('promo') &&
    !excludedPromoPaths.some(
      excludedPath =>
        path === excludedPath || path.startsWith(`${excludedPath}/`),
    );

  return {
    isPromotionalPage,
  };
};
